import { render, staticRenderFns } from "./liveStreamingManage.vue?vue&type=template&id=5508b876&scoped=true&"
import script from "./liveStreamingManage.vue?vue&type=script&lang=ts&"
export * from "./liveStreamingManage.vue?vue&type=script&lang=ts&"
import style0 from "./liveStreamingManage.vue?vue&type=style&index=0&id=5508b876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5508b876",
  null
  
)

export default component.exports